/**
 * CalendarIcon — icône calendrier custom Mytenue (SVG).
 *
 * Design : minimaliste, top bar avec 2 boutons d'attache, grille 3×3, point
 * doré au centre pour signaler "aujourd'hui". Cohérent avec la palette gold
 * (#D4AF72) et noir (#1A1A1A) de la marque.
 *
 * Props :
 *  - size  : taille (default 22)
 *  - color : couleur du trait (default '#1A1A1A')
 *  - dot   : couleur du point central (default gold #D4AF72)
 */

import React from 'react';
import Svg, { Path, Rect, Circle, Line } from 'react-native-svg';

export default function CalendarIcon({ size = 22, color = '#1A1A1A', dot = '#D4AF72' }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Cadre arrondi du calendrier */}
      <Rect
        x="3" y="5" width="18" height="16" rx="2.5"
        stroke={color} strokeWidth="1.6" fill="none"
      />
      {/* Bande haute (header) */}
      <Line x1="3" y1="9.5" x2="21" y2="9.5" stroke={color} strokeWidth="1.6" />
      {/* Anneaux d'attache */}
      <Line x1="8" y1="3" x2="8" y2="6.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
      <Line x1="16" y1="3" x2="16" y2="6.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
      {/* Point central doré (= aujourd'hui) */}
      <Circle cx="12" cy="15" r="2" fill={dot} />
    </Svg>
  );
}
